import styled from "styled-components";

export const Container = styled.main`
  height: 100vh;
  background-color: #041326;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

export const Content = styled.div`
  width: 85%;
  max-width: 600px;
  background-color: rgba(0, 0, 0, 0.5);
  padding: 2rem;

  h1 {
    color: white;
    margin-bottom: 2rem;
    font-family: "Roboto", sans-serif;
    text-align: center;
    font-size: 1.4rem;
  }
  p {
    color: #fff;
    font-size: 1.125rem;
    line-height: 1.5rem;
    width: fit-content;
    font-family: "Roboto", sans-serif;
    line-height: 1.4;
  }
  div {
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    flex-wrap: wrap;
    margin: 0 auto;
    margin-top: 1rem;
    gap: 0.5rem;
    max-width: 415px;
  }
  a {
    width: 3rem;
    height: 3rem;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 0.9rem;
    font-family: "Roboto", sans-serif;
  }
  a > img {
    width: 100%;
    height: 100%;
    margin: 0 1rem;
    border-radius: 0.3rem;
  }
  p + p {
    margin-top: 1rem;
  }
  @media (min-width: 768px) {
    min-height: 20.125rem;

    h1 {
      font-size: 1.8rem;
    }
    p {
      font-size: 1.5rem;

      width: fit-content;
      margin: 0 auto;
    }
    div {
      margin: 0 auto;
      align-items: center;
      justify-content: space-evenly;
      padding: 3rem;
      max-width: none;
    }
    a {
      width: 3.75rem;
      height: 3.75rem;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    a > img {
      width: 3.75rem;
      height: 3.75rem;
    }
  }
`;
